import $http from '@/plugins/axios'

export default {
    getOverviewData (pagination, timeRange, direction) {
        return $http.get(
            '/dashboard/overview-table/',
            {
                params: {
                    ...window.vueapp.$appService.mapPaginationQuery(pagination),
                    ...timeRange,
                    direction: direction ? direction : 'outbound'
                }
            }
        )
    },
    getNumberCallsByCallDuration (timeRange, columns) {
        return $http.get('/dashboard/number-calls-by-call-duration/', {
            params: {
                ...timeRange,
                columns: columns ? columns : 10
            }
        })
    },
    getNumberCallsByTime (timeRange, interval) {
        return $http.get('/dashboard/number-calls-by-time/', {
            params: {
                ...timeRange,
                interval: interval ? interval : '1h'
            }
        })
    },
    getOverviewChart (timeRange) {
        return $http.get('/dashboard/overview-chart/', { params: timeRange })
    }
}
